export default "__VITE_ASSET__Dg8Rnj5G__"